import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { corporateHost } from "~/Utils";
import { SingleCabinLuggagePolicySection2 } from "../SingleCabinLuggagePolicySection/SingleCabinLuggagePolicySection2";
import { GuidelinesForCheckedInSection1 } from "../GuidelinesForCheckedIn/GuidelinesForCheckedInSection1";
import { GuidelinesForCheckedInSection2 } from "../GuidelinesForCheckedIn/GuidelinesForCheckedInSection2";

export const GuidelinesForCheckedinLuggage = () => {
  const query = useQuery();
  const navigate = useNavigate();
  
  const travellersInfoCard =[
    {
      label: "Page Content",
      key: "guidelinesForCheckedinLuggagePageContent",
      children: <GuidelinesForCheckedInSection1 />
    },
    {
        label: "Page Image",
        key: "guidelinesForCheckedinLuggagePageImage",
        children: <GuidelinesForCheckedInSection2 />
    }
  ]


  return (
    // <ContentWrapper>
      <Tabs
      activeKey={query?.get("fourthChildActiveTab") || ""}
      items={travellersInfoCard}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${query.get('subActiveTab')}&thirdChildActiveTab=${query.get('thirdChildActiveTab')}&fourthChildActiveTab=${activeKey}`);
      }}
    ></Tabs>
    // </ContentWrapper>
  );
};
